import { PopupStateData } from 'reactApp/modules/popup/popup.types';
import { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';

const getPopupState = (state: RootState) => state.popup;
export const getOpenPopups = createSelector(getPopupState, (popup): PopupStateData[] => popup.sequence);
